import React from 'react';
import DashboardCard from '../shared/DashboardCard';
import styles from '../../../../styles/DashboardV2.module.css';

interface DocumentHealthWidgetProps {
    totalItems: number;
    completedItems: number;
    expiringItems: number;
    expiredItems: number;
    missingItems: number;
    loading?: boolean;
}

const DocumentHealthWidget: React.FC<DocumentHealthWidgetProps> = ({
    totalItems,
    completedItems,
    expiringItems,
    expiredItems,
    missingItems,
    loading,
}) => {
    const safeTotal = totalItems || 1;
    const validCount = completedItems - expiredItems - expiringItems;
    const validPct   = Math.max(0, (validCount / safeTotal) * 100);
    const expiringPct = (expiringItems / safeTotal) * 100;
    const expiredPct  = (expiredItems / safeTotal) * 100;
    const missingPct  = (missingItems / safeTotal) * 100;

    const bars = [
        { label: 'Valid',         pct: validPct,    count: Math.max(0, validCount), cls: styles.barGreen },
        { label: 'Expiring Soon', pct: expiringPct, count: expiringItems,           cls: styles.barAmber },
        { label: 'Expired',       pct: expiredPct,  count: expiredItems,            cls: styles.barRed   },
        { label: 'Missing',       pct: missingPct,  count: missingItems,            cls: styles.barBlue  },
    ];

    return (
        <DashboardCard
            title="Document Health"
            loading={loading}
        >
            <div className={styles.docHealthSummary}>
                <div className={styles.docHealthStat}>
                    <div className={styles.docHealthStatValue}>{totalItems}</div>
                    <div className={styles.docHealthStatLabel}>Total</div>
                </div>
                <div className={styles.docHealthStat}>
                    <div className={styles.docHealthStatValue} style={{ color: '#10b981' }}>
                        {Math.max(0, validCount)}
                    </div>
                    <div className={styles.docHealthStatLabel}>Valid</div>
                </div>
                <div className={styles.docHealthStat}>
                    <div className={styles.docHealthStatValue} style={{ color: expiringItems > 0 ? '#f59e0b' : '#10b981' }}>
                        {expiringItems}
                    </div>
                    <div className={styles.docHealthStatLabel}>Expiring</div>
                </div>
                <div className={styles.docHealthStat}>
                    <div className={styles.docHealthStatValue} style={{ color: expiredItems > 0 ? '#ef4444' : '#10b981' }}>
                        {expiredItems}
                    </div>
                    <div className={styles.docHealthStatLabel}>Expired</div>
                </div>
            </div>
            <div className={styles.docHealthBars}>
                {bars.map(bar => (
                    <div key={bar.label} className={styles.docHealthBar}>
                        <div className={styles.docHealthBarHeader}>
                            <span className={styles.docHealthBarLabel}>{bar.label}</span>
                            <span className={styles.docHealthBarMeta}>
                                {bar.count} ({bar.pct.toFixed(0)}%)
                            </span>
                        </div>
                        <div className={styles.docHealthBarTrack}>
                            <div
                                className={`${styles.docHealthBarFill} ${bar.cls}`}
                                style={{ width: `${Math.max(bar.pct, bar.count > 0 ? 2 : 0)}%` }}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </DashboardCard>
    );
};

export default DocumentHealthWidget;
